import React, {FC, memo, useEffect, useState} from "react";
import {LiveChatHistoryItem} from "../../../api/types";
import {isEmpty} from "lodash";
import {PinnedMessages} from "../../pinned-live-chat-messages/PinnedMessages";
import {useStateValue} from "../../state-provider/StateProvider";
import useIsMobile from "../../../hooks/useIsMobile";


const VideoPlayerPinnedMessagesOverlayComponent: FC<{
  liveStreamUrl: string | undefined,
}> = ({
  liveStreamUrl,
}) => {

  const [{
    liveChat,
    gridAreaContent,
    liveChatHistories,
  }] = useStateValue()
  const isMobile = useIsMobile()

  const [liveChatLatestMessages, setLiveChatLatestMessage] = useState<LiveChatHistoryItem[]>()
  const [pinned, setPinned] = useState<LiveChatHistoryItem[]>()

  useEffect(() => {
    const activeLiveChat = liveChatHistories.find(
      (h) => h.referenceId === liveChat?.referenceId,
    )
    let messagesToShow = [];
    let pinned;
    if (activeLiveChat) {

      // in messagesToShow only include non-pinned messages
      let messagesToShowLimit = isMobile ? 3 : 4
      if (activeLiveChat.history.length > 0) {
        for (let i = activeLiveChat.history.length - 1; i >= 0; i--) {
          let msg = activeLiveChat.history[i]
          let messagesToConsider = [msg]
          if (msg.replies.length > 0) {
            messagesToConsider.push(...msg.replies)
          }
          for (let k = messagesToConsider.length - 1; k >= 0; k--) {
            if (!messagesToConsider[k].pinned) {
              messagesToShow.push(messagesToConsider[k])
              if (messagesToShow.length >= messagesToShowLimit) {
                break
              }
            }
          }
          if (messagesToShow.length >= messagesToShowLimit) {
            break
          }
        }
      }
      pinned = activeLiveChat.pinned
    }
    setLiveChatLatestMessage(messagesToShow.reverse())
    setPinned(pinned)
  }, [liveChatHistories, liveChat])


  return (
    <>
      { liveChat && (!isEmpty(liveChatLatestMessages) || !isEmpty(pinned)) &&
          <PinnedMessages
              isLiveChatVisible={gridAreaContent === 'LiveChat'}
              liveChatLatestMessages={liveChatLatestMessages}
              pinned={pinned}
              isControlBarHidden={true}
              currentLiveStreamUrl={liveStreamUrl}
          />}
    </>
  )
}

export const VideoPlayerPinnedMessagesOverlay = memo(VideoPlayerPinnedMessagesOverlayComponent)